module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"placeholders":{"addr_line1":"Address line 1","addr_line2":"Address line 2","addr_line3":"Address line 3","town":"Town","county":"Select your county","eircode":"Eircode","search":"Enter full address or Eircode"},"prompt":"Choose your address from the list below","toggle":{"edit":"edit address","enter":"or click here to type in your address","or":"or","reset":"reset"}}}')
  delete Component.options._Ctor
}
